export default __webpack_public_path__ + "static/woman-on-computer-73ea7461c73d95abc115083c8abbb4e0.webp";